import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 扫码登录返回结果
 */
class QRLoginType extends UltMeta {
    /**
     * app扫码登录通知已经被扫描
     */
    QR_LOGIN_SCAN = new Meta(7, "app扫码登录通知已经被扫描");
    /**
     * app扫码登录已经确认
     */
    QR_LOGIN_CONFIRM = new Meta(8, "app扫码登录已经确认");

    /**
     * app扫码登录通知已经过期
     */
    QR_LOGIN_EXPIRED = new Meta(9, "app扫码登录通知已经过期");

    /**
     * app扫码登录通知取消登录
     */
    QR_LOGIN_CANCEL = new Meta(10, "app扫码登录通知取消登录");
}
export const QR_LOGIN_TYPE = new QRLoginType();
